import { OpeningHoursAttributes } from "../attributes/opening-hours-attributes";

class OpeningHours {
  id?: number;
  day_id: number;
  opening_hour: string;
  closing_hour: string;

  day?: string;

  constructor(
    id: number,
    day_id: number,
    opening_hour: string,
    closing_hour: string,
    day?: string
  ) {
    this.id = id;
    this.day_id = day_id;
    this.opening_hour = opening_hour;
    this.closing_hour = closing_hour;
    this.day = day;
  }

  static fromJson(json: OpeningHoursAttributes) {
    if (json === null || json === undefined) {
      return null;
    }

    return new OpeningHours(
      json.id,
      json.day_id,
      json.opening_hour,
      json.closing_hour,
      json.day
    );
  }

  toJson() {
    return {
      day_id: this.day_id,
      opening_hour: this.opening_hour,
      closing_hour: this.closing_hour,
    };
  }
}

export default OpeningHours;
